export default "__VITE_ASSET__CXX$d6SE__"